import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../common/theme/ISpcTheme';

export type IChangeModelStyleClasses = 'changeModelLink' | 'variantSectionChangeModelLink';

const changeModelStyles = makeStyles<ISpcTheme, IChangeModelStyleClasses>(
  () => ({
    changeModelLink: {
      textDecoration: 'underline',
    },
    variantSectionChangeModelLink: {},
  }),
  { name: 'Customise_Summary_ChangeModel' },
);

export default changeModelStyles;
